import { useState } from "react";
import axios from "axios";
import "../styles/Contact.css";

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setStatus("");
    try {
      const API_BASE_URL =
        process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
      const res = await axios.post(`${API_BASE_URL}/api/contact/`, formData);
      if (res.status === 201 || res.status === 200) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Contact submission error:", error.response || error.message);
      setStatus(
        "We could not send your message right now. Please try again, or email us directly at osama@intellusionai.com."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="ix-page">
      <header className="ix-hero">
        <div className="ix-shell">
          <span className="ix-eyebrow">Get in touch</span>
          <h1>Let&rsquo;s talk.</h1>
          <p className="ix-hero-lead">
            Tell us what you are building or what you need. We read every message and
            reply quickly.
          </p>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell cx-grid">
          <div className="cx-form-wrap">
            {status === "success" ? (
              <div className="cx-status cx-status--ok" role="status">
                Thanks. Your message has been sent. We will get back to you shortly.
              </div>
            ) : (
              <form className="cx-form" onSubmit={handleSubmit} noValidate>
                {status && (
                  <p className="cx-status cx-status--err" role="alert">
                    {status}
                  </p>
                )}
                <div className="cx-field">
                  <label htmlFor="cx-name">Name</label>
                  <input
                    id="cx-name"
                    name="name"
                    type="text"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="cx-field">
                  <label htmlFor="cx-email">Email</label>
                  <input
                    id="cx-email"
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="cx-field">
                  <label htmlFor="cx-message">Message</label>
                  <textarea
                    id="cx-message"
                    name="message"
                    rows="5"
                    placeholder="How can we help?"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="ix-btn ix-btn--primary"
                  disabled={submitting}
                >
                  {submitting ? "Sending…" : "Send message →"}
                </button>
              </form>
            )}
          </div>

          <aside className="cx-side">
            <div className="cx-side-block">
              <h3>Email</h3>
              <a href="mailto:osama@intellusionai.com">osama@intellusionai.com</a>
            </div>
            <div className="cx-side-block">
              <h3>Where we are</h3>
              <p>
                <span className="cx-loc">Delaware, USA</span>
                Registered in the State of Delaware, United States.
              </p>
              <p>
                <span className="cx-loc">Islamabad, Pakistan</span>
                Innovation Centre, Bahria University, E8 Sector, Islamabad.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}

export default Contact;
